<template>
  <div class="col-md-12 allocationdetails" :class="['row', 'tableFixHead1']">
    <vue-element-loading
      spinner="line-scale"
      color="#FF6700"
      :active.sync="tableDataLoader"
    />
    <table class="table-hover table-bordered tbl datatables" style="width: 100%">
      <thead>
        <tr>
          <th class="text-center tableheader sticky-header" v-if="IsCheckbox">
            <input
              v-if="IsCheckbox && checkboxDisabled"
              type="checkbox"
              v-model="selectAllCheckbox"
              @click="selectAllItems"
            />
            <span v-if="IsCheckbox && !checkboxDisabled">Select</span>
          </th>
          <th
            class="text-center tableheader sticky-header sticky-last"
            v-for="(col, index) in columns"
            :key="index"
          >
            {{ col.label }}
          </th>
         <th style="position: sticky; background: #e0ddd9" class="text-center tableheader sticky-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!tableDataLoader && !showTableData.length">
          <td :colspan="totalTHCount" align="center">No record found</td>
        </tr>
        <template v-else>
          <tr v-for="(row, index) in showTableData" :key="index">
            <td class="text-center sticky-first" v-if="IsCheckbox">
              <input
                type="checkbox"
                :value="row"
                v-model="selectedItemsOnChild"
                @change="selectedItemdata(row)"
              />
            </td>
            <td
              class="text-center"
              v-for="(col, colIndex) in columns"
              :key="colIndex"
            >
              <span v-if="col.label === 'AWB | MPS ID'">
                {{ row[col.key[0]] }} <br />{{ row[col.key[1]] }}
                <span style="background: yellow" v-if="row[col.key[2]] > 0">
                  <br />{{ row[col.key[2]] }} items
                </span>
              </span>

              <!-- Handle text columns -->
              <span v-if="col.type === 'text'">{{ row[col.key] }}</span>
              <!-- Handle dynamic view link columns -->
              <a
                v-if="col.type === 'link'"
                class="clickable"
                @click="col.action(row.id)"
                ><u><font color="blue">View</font></u></a
              >
              <!-- Handle dynamic button columns -->
              <b-button
                v-if="col.type === 'button'"
                class="btn btn-primary"
                @click="col.action(row.id)"
                style="cursor: pointer; padding: 4px"
              >
                <i v-if="col.btnicon" :class="col.btnicon"></i>
                {{ col.btnlabel }}
              </b-button>
            </td>
            <td>
              <basic-select style="width:300px;" :options="userlist" v-model="row.Srid" name="row.Srid" placeholder="Select SR" :selected-option="row.srItemObj" @select="selectedItemdata($event, row)">
              </basic-select>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";
import {
    BasicSelect
} from "vue-search-select";

export default {
  name: "AllocationTable",
  components: { VueElementLoading,BasicSelect },
  data() {
    return {
      selectedItemsOnChild: [],
      selectAllCheckbox: false,
      SrId:'',
      SrName:''

    };
  },
  props: {
    value: Boolean,
    tableDataLoader: Boolean,
    IsCheckbox: Boolean,
    checkboxDisabled: Boolean,
    IsReload: Boolean,
    showTableData: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    userlist:{
      type:Array
    }
  },
  computed: {
    totalTHCount() {
      return this.columns.length + (this.IsCheckbox ? 1 : 0);
    },
  },
  watch: {
    IsReload(val) {
      if (val == true) {
        this.selectedItemsOnChild = [];
        this.selectAllCheckbox = false;
      }
    },
  },
  methods: {
    selectAllItems(ev) {
      this.selectedItemsOnChild = [];
      if (ev.target.checked == true) {
        for (let i in this.showTableData) {
          this.selectedItemsOnChild.push(this.showTableData[i]);
        }
      } else {
        for (let i in this.showTableData) {
          this.selectedItemsOnChild.pop(this.showTableData[i]);
        }
      }

      if (this.showTableData.length <= 1) {
        for (let i in this.showTableData) {
          this.selectedItemsOnChild.push(this.showTableData[i]);
        }
        for (let i in this.showTableData) {
          this.selectedItemsOnChild.pop(this.showTableData[i]);
        }
      }
      this.selectedItemdata(ev);
    },

    selectedItemdata(selectedValue, row) {
      row.srItemObj = { id: 1, label: 'User 1' } 
      row.Srid = selectedValue.value;
      console.log("-----selectedValue---------"+JSON.stringify(row))
      
      
    },
  },
};
</script>

<style scoped>
.tableFixHead1 {
  overflow-y: auto;
  max-height: 400px;
}

.allocationdetails {
  padding: 0;
  margin: 0;
}

.clickable {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}





th.sticky-header {
  position: sticky;
  top: 0;
  background: #e0ddd9; /* Background for visibility */
  z-index: 10; /* Keep it above other content */
}

td.sticky-first {
  position: sticky;
  left: 0;
  background: white; /* Background for visibility */
  z-index: 5; /* Keep it above other content */
  border:1px solid #dcdfe6;
  box-shadow:0px 0px 12px rgba(0, 0, 0, 0.12);
}

td.sticky-last {
  position: sticky;
  right: 0;
  background: white; /* Background for visibility */
  z-index: 5; /* Keep it above other content */
  border:1px solid #c2cfd6;
  box-shadow:0px 0px 100px rgba(0, 0, 0, 0.12);
}

table tr th:first-child {
  z-index: 11;
}

table tr th {
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0px 0px 10px #c2cfd6;
}
</style>



// WEBPACK FOOTER //
// src/views/components/common/AllocationTable.vue?57b64774